import styled                 from 'styled-components';

import { TypographyVariants } from 'src/components/common/typography';

import { cssFlexColumn,
         cssFlexRow,
         themeColors        } from 'src/providers/theme/shared';



type InvoiceListLookAndFeel = {
  paddings: number[];
  gap: number;

  backgroundColor: string;
  borderColor: string;

  invoiceListGap: number;
  invoiceItemPaddings: number[];
  invoiceItemBorderColor: string;
  invoiceItemGap: number;

  headerTypographyVariant: TypographyVariants;
  invoiceRowKeyTypographyVariant: TypographyVariants;
  invoiceRowValueTypographyVariant: TypographyVariants;
}

const invoicelist_light: InvoiceListLookAndFeel = {
  paddings: [20],
  gap: 10,

  backgroundColor: themeColors.PrimaryWhite,
  borderColor: themeColors.BorderPastelBluePrimary2,

  invoiceListGap: 16,
  invoiceItemPaddings: [10, 16],
  invoiceItemBorderColor: themeColors.SecondaryGray3,
  invoiceItemGap: 3,

  headerTypographyVariant: 'steelw400s12lh16',
  invoiceRowKeyTypographyVariant: 'steelw500s12lh16',
  invoiceRowValueTypographyVariant: 'blackw500s12lh16',
}

export type InvoiceListVariants = 'light';

export const invoicelist_variants: Map<InvoiceListVariants, InvoiceListLookAndFeel> = 
  new Map<InvoiceListVariants, InvoiceListLookAndFeel>([
    ['light', invoicelist_light],
  ]);

export const Wrapper = styled.div<{
  lookAndFeel: InvoiceListLookAndFeel;
}>`
  width: 100%;
  position: relative;
  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 12px;
  background-color: ${(args) => args.lookAndFeel.backgroundColor} !important;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
`;

export const Container = styled.div<{
  lookAndFeel: InvoiceListLookAndFeel;
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.gap}px;
`

export const InvoiceListContainer = styled.div<{
  lookAndFeel: InvoiceListLookAndFeel;
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.invoiceListGap}px;
`

export const InvoiceItem = styled.div<{
  lookAndFeel: InvoiceListLookAndFeel;
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.invoiceItemGap}px;
`

export const InvoiceItemRow = styled.div<{
  lookAndFeel: InvoiceListLookAndFeel;
}>`
  ${cssFlexRow};
  justify-content: space-between;
`
